interface ReadonlyFieldProps {
  label: string;
  content: JSX.Element | string;
}

export default function ReadonlyField(props: Readonly<ReadonlyFieldProps>) {
  const { label, content } = props;
  return (
    <div className='flex flex-col gap-1'>
      <p className='text-sm font-semibold'>{label}</p>
      <div className='rounded bg-gray-100 px-3.5 py-2.5'>
        {typeof content !== 'string' ? content : <span>{content}</span>}
      </div>
    </div>
  );
}
